module.exports = __webpack_public_path__ + "static/media/img-talent-profile-top.d36b2bdc.png";